import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectAccountBalance } from 'app/lib/account/selectors';
import selectCurrency from 'app/redux/selectors/сurrency';

import { Amount } from '../Amount';

type BalanceProps = {
  className?: string;
 };

export const Balance: FC<BalanceProps> = ({
  className,
}) => {
  const accountBalance = useSelector(selectAccountBalance);
  const currency = useSelector(selectCurrency);

  if (typeof accountBalance !== 'number') {
    return null;
  }

  return (
    <Amount value={accountBalance}
            className={className}
            currency={currency} />
  );
};

